var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.051 10.441h-.727v11.362h17.453V10.441h-.728v10.635H4.051V10.441z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.251 10.241v10.635H19.85V10.241h1.128v11.762H3.123V10.241H4.25zm15.798.2h.727v11.362H3.324V10.441h.727v10.635H20.05V10.441zm-6.817-5.893h-2.363v.727h2.363v-.727zm5.636.727h1.181v2.909H4.051v-2.91h1.182v-.726H3.324V8.91h17.453V4.548h-1.91v.727z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.432 4.348v1.127h-2.763V4.348h2.763zm5.236 1.127V4.348h2.309V9.11H3.123V4.348h2.309v1.127H4.251v2.509H19.85v-2.51h-1.181zm-13.435-.2H4.051v2.909H20.05v-2.91h-1.181v-.726h1.909V8.91H3.323V4.548h1.909v.727zm5.636-.727h2.363v.727h-2.363v-.727z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.142 3.457a1.09 1.09 0 00-2.182 0v2.181a1.09 1.09 0 002.182 0V3.457z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.05 2.741a.716.716 0 00-.715.716v2.181a.716.716 0 001.432 0V3.457a.716.716 0 00-.716-.716zm-1.465.716a1.466 1.466 0 012.932 0v2.181a1.466 1.466 0 11-2.932 0V3.457z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.14 3.457a1.09 1.09 0 00-2.181 0v2.181a1.09 1.09 0 002.182 0V3.457z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.05 2.741a.716.716 0 00-.716.716v2.181a.716.716 0 001.432 0V3.457a.716.716 0 00-.716-.716zm-1.466.716a1.466 1.466 0 012.932 0v2.181a1.466 1.466 0 01-2.932 0V3.457zm.375 7.293l1.796 1.797-5.795 5.795-3.614-3.614 1.796-1.796 1.818 1.818 3.999-4z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.959 10.22l2.326 2.327-6.325 6.325-4.145-4.144 2.327-2.326 1.818 1.818 3.999-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingOutline);
export default __webpack_public_path__ + "ef8237604453df068ba5272ebf928f56.svg";
export { ForwardRef as ReactComponent };